import type { PositionFields } from '@/data/position/model';
import Monolith from '@/shared/api/monolith';
import { parseAPIError } from '@/shared/redux/helpers/parseApiError';
import { createWiwAsyncThunk } from '@/store';

type ReplacePositionsRequest =
  | {
      [key: string]: any; // update later with possible params
    }
  | undefined;

type ReplacePositionsResponse = {
  positions: PositionFields[];
};

export const replacePositions = createWiwAsyncThunk<ReplacePositionsResponse, ReplacePositionsRequest>(
  'position/replace',
  async (params = {}, { rejectWithValue }) => {
    try {
      return (await Monolith.url('/positions').query(params).get()) as ReplacePositionsResponse;
    } catch (error) {
      return rejectWithValue(parseAPIError(error));
    }
  },
);
